
















import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'
import { ProfissionalExecutanteContrato } from '@/types/_'

@Component
export default class ComponentModalAddProfissionais extends Vue {
  loadingBusca: boolean = false
  addProfissionaisLoading: boolean = false

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get addProfissionaisList() {
    return this.getBackofficeContratosStore.modal.addProfissionaisList
  }

  get profissionaisExecutantes(): ProfissionalExecutanteContrato[] {
    return this.getBackofficeContratosStore.profissionaisExecutantes
  }

  get selecionados(): ProfissionalExecutanteContrato[] {
    return this.getBackofficeContratosStore.selectedProfissionais
  }

  @Watch('addProfissionaisList')
  onToggleModal(isOpen: boolean) {
    if (isOpen) {
      this.getBackofficeContratosStore.clearProfissionaisExecutantes()
      this.getBackofficeContratosStore.clearSelectedProfissionais()
    }
  }

  subtitulo(profissional: ProfissionalExecutanteContrato): string {
    return `${formatCpf(profissional.cpf)} · ${this.detalhe(profissional)}`
  }

  detalhe(profissional: ProfissionalExecutanteContrato): string {
    if (!profissional.crm) {
      return profissional.email || 'sem e-mail'
    }

    const uf = profissional.crmUf ? `/${profissional.crmUf}` : ''

    return `CRM ${profissional.crm}${uf}`
  }

  async onBusca(payload: { nome?: string, cpf?: string }) {
    this.loadingBusca = true

    const response = await this.getBackofficeContratosStore.getProfissionaisBySearch(payload)

    this.loadingBusca = false

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao buscar os profissionais.', 'error'))
    }
  }

  onToggle(profissional: ProfissionalExecutanteContrato) {
    const jaSelecionado = this.selecionados.some((item: ProfissionalExecutanteContrato) => item.id === profissional.id)

    if (jaSelecionado) {
      this.getBackofficeContratosStore.setSelectedProfissionais(this.selecionados.filter((item: ProfissionalExecutanteContrato) => item.id !== profissional.id))
      return
    }

    this.getBackofficeContratosStore.setSelectedProfissionais([...this.selecionados, profissional])
  }

  async onConfirmar() {
    this.addProfissionaisLoading = true
    await this.getBackofficeContratosStore.addProfissionais()
    this.addProfissionaisLoading = false
    this.onClose()
  }

  onClose() {
    this.getBackofficeContratosStore.clearProfissionaisExecutantes()
    this.getBackofficeContratosStore.clearSelectedProfissionais()
    this.getBackofficeContratosStore.setShowModalAddProfissionaisList(false)
  }
}

function formatCpf(cpf?: string | null): string {
  if (!cpf) {
    return ''
  }

  if (cpf.length !== 11) {
    return cpf
  }

  return `${cpf.substring(0, 3)}.${cpf.substring(3, 6)}.${cpf.substring(6, 9)}-${cpf.substring(9, 11)}`
}
